import React, { Component } from "react";
class Payment3DApproved extends Component {
    render() {
        return (<div className="container">
            <h1>Approved</h1>
        </div>);
    }
}
export default Payment3DApproved;